import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AppLayout, PageHeader } from "@/components/Layout";
import { Store, UtensilsCrossed, MapPin, Globe, Gift } from "lucide-react";

const Card = ({ item, index, FallbackIcon }) => (
  <div data-testid={`vendor-card-${item.id}`}
    className="flex gap-3 rounded-xl border border-border bg-card p-3 shadow-sm animate-fade-up"
    style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}>
    <div className="grid h-16 w-16 shrink-0 place-items-center overflow-hidden rounded-lg bg-muted">
      {item.logo ? (
        <img src={item.logo} alt={item.name} className="h-full w-full object-cover" />
      ) : (
        <span className="grid h-full w-full place-items-center bg-primary/10 text-primary"><FallbackIcon size={22} /></span>
      )}
    </div>
    <div className="flex-1">
      <h3 className="font-display text-lg font-bold leading-tight text-primary">{item.name || "Coming soon"}</h3>
      {item.booth && (
        <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-secondary">
          <MapPin size={13} /> {item.booth}
        </p>
      )}
      {item.description && <p className="mt-1 text-sm text-foreground/80">{item.description}</p>}
      <div className="mt-1.5 flex flex-wrap items-center gap-2">
        {item.special_offer && (
          <span className="inline-flex items-center gap-1 rounded-full bg-secondary/15 px-2 py-0.5 text-[11px] font-bold text-secondary">
            <Gift size={12} /> {item.special_offer}
          </span>
        )}
        {item.website && (
          <a href={item.website} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-1 text-xs font-semibold text-primary underline underline-offset-2">
            <Globe size={12} /> Website
          </a>
        )}
      </div>
    </div>
  </div>
);

const Section = ({ title, icon: Icon, items, fallbackIcon }) => (
  <div>
    <div className="mb-2 flex items-center gap-2">
      <Icon size={18} className="text-secondary" />
      <h2 className="font-display text-xl font-bold text-primary">{title}</h2>
    </div>
    {items.length === 0 ? (
      <p className="rounded-xl border border-dashed border-border bg-card/50 p-4 text-sm text-muted-foreground">
        {title} will be listed here as they are confirmed.
      </p>
    ) : (
      <div className="space-y-2">
        {items.map((it, i) => <Card key={it.id} item={it} index={i} FallbackIcon={fallbackIcon} />)}
      </div>
    )}
  </div>
);

export default function Vendors() {
  const [vendors, setVendors] = useState([]);
  const [trucks, setTrucks] = useState([]);

  useEffect(() => {
    api.get("/vendors").then((r) => setVendors(r.data)).catch(() => {});
    api.get("/food_trucks").then((r) => setTrucks(r.data)).catch(() => {});
  }, []);

  return (
    <AppLayout>
      <PageHeader subtitle="On the Grounds" title="Vendors & Food" />
      <div className="space-y-6 px-4 pt-2" data-testid="vendors-page">
        <Section title="Vendors" icon={Store} items={vendors} fallbackIcon={Store} />
        <Section title="Food Trucks" icon={UtensilsCrossed} items={trucks} fallbackIcon={UtensilsCrossed} />
      </div>
    </AppLayout>
  );
}
